// extracted by mini-css-extract-plugin
export var hero = "Hero-module--hero--LhZml";
export var heroWrapper = "Hero-module--heroWrapper--JqKkl";
export var left = "Hero-module--left--lGOJG";
export var logo = "Hero-module--logo--fMuqa";
export var search = "Hero-module--search--LpiQu";
export var searchResults = "Hero-module--searchResults--XRJVK";
export var searchWrapper = "Hero-module--searchWrapper--NxFl3";
export var textWrapper = "Hero-module--textWrapper--f6tYN";
export var texts = "Hero-module--texts--+nIFr";
export var wrapper = "Hero-module--wrapper--qoidL";